export interface CsvColumn {
  key: string;
  header: string;
}

/** RFC4180: 쉼표/큰따옴표/개행 포함 시 큰따옴표로 감싸고 내부 `"` 는 `""` 로 이스케이프. */
function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  const s = String(value);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** 행 배열을 CSV 문자열로. 헤더 행 포함, 컬럼 순서 유지. */
export function toCsv(rows: Record<string, unknown>[], columns: CsvColumn[]): string {
  const header = columns.map((c) => escapeCell(c.header)).join(',');
  const body = rows.map((row) => columns.map((c) => escapeCell(row[c.key])).join(','));
  return [header, ...body].join('\n');
}

/** Blob 을 파일로 다운로드(브라우저). */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** 임의 객체를 pretty JSON 파일로 다운로드. */
export function downloadJson(filename: string, data: unknown): void {
  downloadBlob(filename, new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
}

/** 행 배열을 CSV 파일로 다운로드. */
export function downloadCsv(
  filename: string,
  rows: Record<string, unknown>[],
  columns: CsvColumn[]
): void {
  downloadBlob(filename, new Blob([toCsv(rows, columns)], { type: 'text/csv;charset=utf-8' }));
}
